import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createActiveOrgSlice } from './ActiveOrg'
import { IActiveOrgStore } from './ActiveOrg/interface'

// Persist the active org to localStorage (default persist storage) so it
// survives reloads. helpers/team-access reads the persisted value directly
// from localStorage under this `name` (for the api-client's Org-Id header), so
// keep the `name` in sync with ACTIVE_ORG_STORAGE_KEY in helpers/team-access.
export const useActiveOrgStore = create<IActiveOrgStore>()(
  persist(
    (...a) => ({
      ...createActiveOrgSlice(...a),
    }),
    {
      name: 'active-org-store',
      partialize: (state) => ({ activeOrgId: state.activeOrgId }),
    },
  ),
)
